"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MARKDOWN_STYLE = void 0;
exports.escapeHtml = escapeHtml;
exports.looksLikeMarkdown = looksLikeMarkdown;
exports.markdownToHtml = markdownToHtml;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * 轻量 Markdown → HTML 转换（管理后台版本）。
 *
 * <p><b>为什么和小程序端各有一份</b>：两端构建产物互相不可引用（小程序走 HBuilderX、
 * 后台走 webpack，且小程序侧不能依赖后台的 @/ 别名）。两份实现保持同一套规则，
 * 改规则时两边都要改。规则本身很窄，稳定性比复用性更重要。</p>
 *
 * <p>支持：标题、加粗/斜体、行内代码、代码块、有序/无序列表、引用、分割线、段落换行、链接。</p>
 *
 * <p>安全策略：先对原始文本做 HTML 转义，再生成自己的标签。
 * 模型输出里的 {@code <script>}、{@code <img onerror=...>} 只会显示成字面文本。
 * 链接只放行 http/https，挡掉 {@code javascript:} 伪协议。</p>
 */

var ESCAPE_MAP = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};
function escapeHtml(text) {
  return String(text == null ? '' : text).replace(/[&<>"']/g, function (char) {
    return ESCAPE_MAP[char];
  });
}

/**
 * 判断是否需要用富文本渲染。
 *
 * <p>纯文本继续走 {@code <div>} 直出：更轻，也不会因为误判把原有排版改掉。</p>
 */
function looksLikeMarkdown(text) {
  var value = String(text == null ? '' : text);
  if (!value.trim()) return false;
  return /(^|\n)\s{0,3}(#{1,6}\s|[-*+]\s|\d+\.\s|>\s|```)/.test(value) || /\*\*[^*\n]+\*\*/.test(value) || /`[^`\n]+`/.test(value) || /\[[^\]\n]+\]\((https?:[^)\s]+)\)/.test(value) || /(^|\n)\s{0,3}---+\s*(\n|$)/.test(value);
}

/** 行内语法：加粗、斜体、行内代码、链接。输入必须已转义。 */
function renderInline(escaped) {
  var html = escaped;

  // 行内代码先占位，避免其中的 * _ [ ] 被后续规则误伤
  var codes = [];
  html = html.replace(/`([^`\n]+)`/g, function (match, code) {
    codes.push("<code>".concat(code, "</code>"));
    return "\0CODE".concat(codes.length - 1, "\0");
  });

  // 链接：只允许 http/https
  html = html.replace(/\[([^\]\n]+)\]\((https?:\/\/[^)\s]+)\)/g, function (match, label, url) {
    return "<a href=\"".concat(url, "\" target=\"_blank\" rel=\"noopener noreferrer\">").concat(label, "</a>");
  });
  html = html.replace(/\*\*([^*\n]+)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/__([^_\n]+)__/g, '<strong>$1</strong>');
  html = html.replace(/(^|[\s(])\*([^*\n]+)\*/g, '$1<em>$2</em>');
  html = html.replace(/(^|[\s(])_([^_\n]+)_/g, '$1<em>$2</em>');
  html = html.replace(/\u0000CODE(\d+)\u0000/g, function (match, index) {
    return codes[Number(index)] || '';
  });
  return html;
}

/**
 * 把 Markdown 转成 HTML 片段。
 */
function markdownToHtml(text) {
  var source = String(text == null ? '' : text).replace(/\r\n?/g, '\n');
  if (!source.trim()) return '';
  var lines = source.split('\n');
  var out = [];
  var paragraph = [];
  var list = null; // { type: 'ul' | 'ol', items: [] }
  var quote = [];
  var codeFence = null; // { lang: string, lines: [] }

  var flushParagraph = function flushParagraph() {
    if (!paragraph.length) return;
    // 段内换行保留成 <br/>：模型经常用单换行分行，丢掉会和原文观感差很远
    out.push("<p>".concat(renderInline(escapeHtml(paragraph.join('\n'))).replace(/\n/g, '<br/>'), "</p>"));
    paragraph = [];
  };
  var flushList = function flushList() {
    if (!list) return;
    var tag = list.type;
    var items = list.items.map(function (item) {
      return "<li>".concat(renderInline(escapeHtml(item)), "</li>");
    }).join('');
    out.push("<".concat(tag, ">").concat(items, "</").concat(tag, ">"));
    list = null;
  };
  var flushQuote = function flushQuote() {
    if (!quote.length) return;
    out.push("<blockquote>".concat(renderInline(escapeHtml(quote.join('\n'))).replace(/\n/g, '<br/>'), "</blockquote>"));
    quote = [];
  };
  var _iterator = _createForOfIteratorHelper(lines),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var rawLine = _step.value;
      var line = rawLine.replace(/\s+$/, '');

      // 代码块内部原样收集，不做任何语法处理
      if (codeFence) {
        if (/^\s{0,3}```/.test(line)) {
          out.push("<pre><code>".concat(escapeHtml(codeFence.lines.join('\n')), "</code></pre>"));
          codeFence = null;
        } else {
          codeFence.lines.push(rawLine);
        }
        continue;
      }
      var fenceMatch = line.match(/^\s{0,3}```(\w*)\s*$/);
      if (fenceMatch) {
        flushParagraph();
        flushList();
        flushQuote();
        codeFence = {
          lang: fenceMatch[1] || '',
          lines: []
        };
        continue;
      }
      if (!line.trim()) {
        flushParagraph();
        flushList();
        flushQuote();
        continue;
      }
      var headingMatch = line.match(/^\s{0,3}(#{1,6})\s+(.*)$/);
      if (headingMatch) {
        flushParagraph();
        flushList();
        flushQuote();
        var level = headingMatch[1].length;
        out.push("<h".concat(level, ">").concat(renderInline(escapeHtml(headingMatch[2])), "</h").concat(level, ">"));
        continue;
      }
      if (/^\s{0,3}(-{3,}|\*{3,}|_{3,})\s*$/.test(line)) {
        flushParagraph();
        flushList();
        flushQuote();
        out.push('<hr/>');
        continue;
      }
      var quoteMatch = line.match(/^\s{0,3}>\s?(.*)$/);
      if (quoteMatch) {
        flushParagraph();
        flushList();
        quote.push(quoteMatch[1]);
        continue;
      }
      var unordered = line.match(/^\s{0,3}[-*+]\s+(.*)$/);
      var ordered = line.match(/^\s{0,3}\d+[.)]\s+(.*)$/);
      if (unordered || ordered) {
        flushParagraph();
        flushQuote();
        var type = unordered ? 'ul' : 'ol';
        if (list && list.type !== type) flushList();
        if (!list) list = {
          type: type,
          items: []
        };
        list.items.push((unordered || ordered)[1]);
        continue;
      }

      // 列表项的缩进续行并入上一项，避免长条目被拆成两个 li
      if (list && /^\s{2,}\S/.test(rawLine)) {
        list.items[list.items.length - 1] += " ".concat(line.trim());
        continue;
      }
      flushList();
      flushQuote();
      paragraph.push(line);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (codeFence) out.push("<pre><code>".concat(escapeHtml(codeFence.lines.join('\n')), "</code></pre>"));
  flushParagraph();
  flushList();
  flushQuote();
  return out.join('');
}

/** 富文本样式：字号与聊天正文对齐，代码块用浅灰底。 */
var MARKDOWN_STYLE = exports.MARKDOWN_STYLE = "\n.markdown-body { font-size: 13px; line-height: 1.62; color: #303133; word-break: break-word; }\n.markdown-body p { margin: 0 0 6px; }\n.markdown-body p:last-child { margin-bottom: 0; }\n.markdown-body h1, .markdown-body h2, .markdown-body h3,\n.markdown-body h4, .markdown-body h5, .markdown-body h6 {\n  margin: 8px 0 6px; font-weight: 600; line-height: 1.4; color: #1f2329;\n}\n.markdown-body h1 { font-size: 17px; }\n.markdown-body h2 { font-size: 16px; }\n.markdown-body h3 { font-size: 15px; }\n.markdown-body h4, .markdown-body h5, .markdown-body h6 { font-size: 14px; }\n.markdown-body ul, .markdown-body ol { margin: 0 0 8px; padding-left: 20px; }\n.markdown-body li { margin: 2px 0; line-height: 1.6; }\n.markdown-body blockquote {\n  margin: 0 0 8px; padding: 4px 0 4px 10px;\n  border-left: 3px solid #f0d6c6; color: #7a7a7a;\n}\n.markdown-body code {\n  padding: 1px 4px; border-radius: 3px; background: #f4f4f5;\n  font-family: Consolas, Monaco, monospace; font-size: 12px;\n}\n.markdown-body pre {\n  margin: 0 0 8px; padding: 8px; border-radius: 5px;\n  background: #f7f7f8; overflow-x: auto;\n}\n.markdown-body pre code { padding: 0; background: transparent; }\n.markdown-body hr { margin: 10px 0; border: 0; border-top: 1px solid #ececec; }\n.markdown-body a { color: #d95b2d; text-decoration: none; }\n.markdown-body a:hover { text-decoration: underline; }\n.markdown-body strong { font-weight: 600; }\n";